import React from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import FieldRow from "./FieldRow";

/**
 * Step 2 — set password for the freshly created lead.
 * Pure presentational: receives state + submit handler from RegisterDialog.
 */
export default function RegisterStep2({
  form, setForm, status, error, onSubmit,
  onPasswordTyped, // clears `error` status when the user starts typing again
}) {
  const handle = (key) => (v) => {
    setForm({ ...form, [key]: v });
    onPasswordTyped?.();
  };
  return (
    <form data-testid="lead-form-step2" onSubmit={onSubmit} className="mt-5 space-y-4">
      <FieldRow
        id="password" type="password"
        label="Password (almeno 8 caratteri)" testId="lead-password"
        value={form.password} onChange={handle("password")}
        required minLength={8} placeholder="Minimo 8 caratteri"
      />
      <FieldRow
        id="password2" type="password"
        label="Ripeti la password" testId="lead-password-confirm"
        value={form.password2} onChange={handle("password2")}
        required minLength={8} placeholder="Reinserisci la password"
      />
      {form.password && form.password2 && form.password !== form.password2 && status !== "error" && (
        <p data-testid="lead-password-mismatch-hint" className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
          Le due password non coincidono.
        </p>
      )}
      {status === "error" && (
        <p data-testid="lead-step2-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
          {error}
        </p>
      )}
      <button
        type="submit"
        data-testid="lead-step2-submit"
        disabled={status === "loading"}
        className="cta-btn w-full mt-2 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {status === "loading" ? (<><Loader2 className="animate-spin" size={18} /> Salvo…</>)
          : status === "success" ? (<>Reindirizzo…</>)
          : (<>Crea account e vai alla Lezione 1</>)}
      </button>
      <div className="flex items-start gap-2 pt-1">
        <ShieldCheck size={14} className="mt-0.5" style={{ color: "var(--np-muted)" }} />
        <p className="text-[12px] leading-relaxed" style={{ color: "var(--np-muted)" }}>
          Step 2 di 2 · La password ti serve per rientrare da qualsiasi dispositivo.
        </p>
      </div>
    </form>
  );
}
